"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var ChipBreadcrumb = (0, material_1.styled)(material_1.Chip)(function (_a) {
    var theme = _a.theme;
    var backgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800];
    return {
        backgroundColor: backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: (0, material_1.emphasize)(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: (0, material_1.emphasize)(backgroundColor, 0.12),
        },
    };
});
exports.default = ChipBreadcrumb;
